export const IMAGE_TAGS = {
  HISTORIQUE: "HISTORIQUE",
  VISITE_DE_SITE: "VISITE DE SITE",
  INTERVENTION: "INTERVENTION",
};
export const FILE_TAGS = {
  SOUS_TRAITANT: "SOUS TRAITANT",
  MACRO_ANALYSE: "MACRO ANALYSE",
};

export const imageExtensions = [".png", ".jpg", ".jpeg"];

export const previewableMimeTypes = new Set([
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
  "image/svg+xml",
  "image/avif",
  "application/pdf",
]);
export const previewableExtensions = new Set([
  ".png",
  ".jpg",
  ".jpeg",
  ".jfif",
  ".webp",
  ".gif",
  ".svg",
  ".avif",
  ".pdf",
]);
